function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "shirt_M",
  d: "M-13884.875,720h-7.651v-7.941l-1.315,1.4-2.158-1.751c.165-.26.33-.557.489-.845.679-1.215,1.52-2.723,2.929-2.866h1.663a2.264,2.264,0,0,0,2.246,1.956,2.266,2.266,0,0,0,2.249-1.956h1.607c1.387.116,2.207,1.557,2.931,2.829l.007.012c.186.325.361.633.536.9l-2.131,1.782-1.4-1.461V720Zm-2.647-5.137v2.64h1.249v-4.9h-1.249l-1.252,2.1-1.245-2.1h-1.252v4.9h1.252v-2.633l1.183,1.96h.125l1.188-1.964Z",
  transform: "translate(13896 -707.998)"
});

function SvgShirtM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.657 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirtM);
export default __webpack_public_path__ + "static/media/shirt_m.115cfdad.svg";
export { ForwardRef as ReactComponent };